import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "2 2 20 20",
	strokeWidth: 1.5,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "inherit",
		d: "M13.25 8.75L9.75 12L13.25 15.25"
	})
});
export default SvgChevronLeft;
